module.exports = __webpack_public_path__ + "static/media/topo.cd054a17.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/topo.webp
// module id = 242
// module chunks = 0